import React, {
  useRef, useEffect,
} from 'react';
import gsap from 'gsap';
import cn from 'classnames';
import { HtmlContent } from '../common';
import { isClient } from '../../utils/helpers';
import './AnnouncementBar.scss';

const AnnouncementBar = (props) => {
  const {
    hidden = false, // The announcement bar is enabled, but needs to be hidden temporarily
    message,
  } = props;


  // Hide the announcement bar like an accordion.
  const ref = useRef(null);


  useEffect(() => {
    if (ref.current) {
      gsap.to(ref.current, {
        height: !hidden ? 'auto' : 0,
        opacity: !hidden ? 1 : 0,
        pointerEvents: !hidden ? 'all' : 'none',
        duration: 0.2,
        ease: 'power.inOut',
        onUpdate: () => {
          if (isClient && ref.current) {
            const height = ref.current.clientHeight;
            document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
          }
        },
        onComplete: () => {
          if (isClient && ref.current) {
            const height = ref.current.clientHeight;
            document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
          }
        },
      });
    }
  }, [hidden]);


  useEffect(() => {
    const updateHeightVar = () => {
      if (isClient && ref.current) {
        const height = ref.current.clientHeight;
        document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
      }
    };

    // Set once on mount
    updateHeightVar();

    if (!isClient) return undefined;
    const handleResize = () => updateHeightVar();
    window.addEventListener('resize', handleResize, false);
    return () => {
      window.removeEventListener('resize', handleResize, false);
    };
  }, []);


  return (
    <banner
      ref={ref}
      className={cn(
        'announcement-bar',
        hidden && 'announcement-bar--hidden',
      )}
    >
      <div className="container">
        <HtmlContent content={message?.html} />
      </div>
    </banner>
  );
};

export default AnnouncementBar;
